const options = {
  5: "bg-indigo-100/5",
  10: "bg-indigo-100/10",
  25: "bg-indigo-100/25",
  50: "bg-indigo-100/50",
  75: "bg-indigo-100/75",
  90: "bg-indigo-100/90",
  100: "bg-indigo-100",
};

const from = {
  5: "from-indigo-100/5",
  10: "from-indigo-100/10",
  25: "from-indigo-100/25",
  50: "from-indigo-100/50",
  75: "from-indigo-100/75",
  90: "from-indigo-100/90",
  100: "from-indigo-100",
};

export default function getBackgroundIndigo100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
